import React, { useMemo, useState } from 'react';
import { Layout, Seo } from '@layout';
import { saveTheDateDesignsPageData as pageData } from '@data-ts/pages/save-the-date';
import { graphql } from 'gatsby';
import { HighQualityPrintsSection, HowItWorksSection, WonderFulWebsiteSection, EcoSection } from '@sections/save-the-date';
import { ColoredBlockSection } from '@sections/shared/ColoredBlockSection';
import { faqQuestionsData } from '@data-ts/components/FaqQuestions';
import { FaqList } from '@components/FaqList';
import { AbcSection } from '@sections/shared/AbcSection';
import { GalleryPageContent } from '@components/GalleryComponents/GalleryPageContent/GalleryPageContent';
import { saveTheDateDesignsCanonicalUrl } from '@utils/gallery.util';
import { productTypes } from '@data-ts/components/GalleryComponents/GalleryPageContent';
import { saveTheDatePhotoECards } from '@components/GalleryComponents/GalleryComponents.constants';
import { createFilterGroupsProcessor } from '@utils/joyPrint.utils';

export const query = graphql`
  {
    bliss {
      stationeryTemplatesByCategory(category: saveTheDate) {
        themeId
      }
      themeVariants(variantTypes: [savethedate]) {
        variationType
        imageUrl
        printUrl
        vendor
        tags
        colors
        font
        variantColor
        variantName
        variantThemeId
        theme {
          id
          name
          themeId
          marketingData {
            variationType
            imageUrl
            printUrl
            vendor
            tags
            colors
            font
            variantColor
            variantName
            variantThemeId
            theme {
              name
              themeId
            }
          }
        }
      }
    }
  }
`;

const page: MarcomPageName = 'save-the-date';

const SaveTheDate = ({ data }: { data: BlissGalleryECardsThemesData }) => {
  let cards: MarketingData = data.bliss.themeVariants.filter(v => v.theme).concat(saveTheDatePhotoECards);
  const [chromeless, setChromeless] = useState(false);

  const processFilterGroups = useMemo(() => {
    return createFilterGroupsProcessor(productTypes.saveTheDate, data.bliss);
  }, [data]);

  return (
    <Layout
      isTransparentHeader={true}
      transparentJoyLogoColor="purple6"
      transparentHeaderButtonVariant="primary"
      transparentHeaderLinkVariant="navLink"
      page={page}
      chromeless={chromeless}
    >
      <Seo title={pageData.seo.title} description={pageData.seo.content} canonicalURL={saveTheDateDesignsCanonicalUrl} />
      <GalleryPageContent
        page={page}
        productType={productTypes.saveTheDate}
        cards={cards}
        hasPhotoECards
        processFilterGroups={processFilterGroups}
        showModal={isModalOpened => {
          setChromeless(isModalOpened);
        }}
      />
      <HighQualityPrintsSection />
      <HowItWorksSection />
      <WonderFulWebsiteSection />
      <EcoSection />
      <ColoredBlockSection
        isLeftAligned
        backgroundColor="humana1Light"
        sideHeaderText={'Frequently <br/> Asked <br/> Questions'}
        sectionId="Save_the_Date_Design_FAQ"
        isToggleNeeded={true}
      >
        <FaqList accordion={true} questionNodes={[...faqQuestionsData.saveTheDateDesign, ...faqQuestionsData.general]} color="neutra6" />
      </ColoredBlockSection>
      <AbcSection page={page} abcSectionId="Save_the_Date_Design_ABC_CTA" />
    </Layout>
  );
};

export default SaveTheDate;
